// extracted by mini-css-extract-plugin
export default {"section":"Products_section__qqK6t","wrapper":"Products_wrapper__R9xtb"};